import Cookies from "js-cookie";

import { safeParse } from "./json";

const CONTEXT_COOKIE_EXPIRY_DAYS = 3;
const context = {
  get: () => safeParse(Cookies.get(`context`)),
  set: (value) => {
    const options = { expires: CONTEXT_COOKIE_EXPIRY_DAYS };
    Cookies.set(`context`, value, options);
  },
};

const service = {
  context
};

export default service;
